import { searchPromotedEvents } from '@eventbrite/ads';
import { transformDestinationEvent } from '@eventbrite/event-renderer';
import { useQuery } from '@tanstack/react-query';
import {
    EventSearchInterfaceName,
    transformToPromotedEventSearchApiPayload,
} from '../../../../api/searchAllEvents';
import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { useBaseSearchQuery } from '../../hooks/queries/events';

export function usePromotedEvent({
    search = {},
    bucketName,
    enabled,
    slots = 1,
}: {
    search?: OrganicEventSearchFiltersApiPayload;
    bucketName: EventSearchInterfaceName;
    enabled: boolean;
    slots: number;
}) {
    const overloadedQuery = useBaseSearchQuery(search);
    const apiPayload = transformToPromotedEventSearchApiPayload({
        slots,
        interfaceName: bucketName,
        event_search: {
            ...overloadedQuery,
            page: 1,
        },
    });

    const { data: promotedEvents, isFetching: arePromotedEventsLoading } =
        useQuery({
            queryKey: ['category-browse', 'promoted', apiPayload],
            queryFn: () => searchPromotedEvents(apiPayload),
            staleTime: 0,
            refetchOnMount: true,
            select: (events) => events.map(transformDestinationEvent),
            // Wait until the base query is done loading to enable this
            // follow up one. This will allow for us to not duplicate events
            enabled,
        });

    return {
        promotedEvents,
        arePromotedEventsLoading,
    };
}
